<template>
  <v-container fluid>
    <v-card v-if="showCardOverlay" class="pa-4">
      <v-layout row wrap>
        <v-flex xs12 class="pa-2 animated-background"> </v-flex>
      </v-layout>
    </v-card>
    <v-card v-else class="pa-4">
      <v-layout row wrap>
        <v-flex xs12 class="pa-2">
          <v-card hover :to="$t('urlGodfather')">
            <v-img
              src="/image/friends.jpg"
              gradient="to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)"
              min-height="200"
              aspect-ratio="4.00"
            >
              <v-layout pa-3 column fill-height class="white--text">
                <v-spacer></v-spacer>
                <v-flex shrink>
                  <div class="headline">{{ $t('promos.godfather.title') }}</div>
                </v-flex>
              </v-layout>
            </v-img>

            <v-card-actions class="pa-0">
              <v-btn flat block class="primary initialize">
                {{ $t('promos.godfather.button') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>

        <v-flex
          xs12
          :class="{ sm6: !onlyOnePromo }"
          class="pa-2"
          v-for="(promo, index) in promos"
          :key="index"
        >
          <v-card hover class="flexcard" height="100%">
            <v-img
              :src="promo.background"
              position="top center"
              gradient="to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)"
              min-height="200"
              max-height="200"
              aspect-ratio="3.00"
            >
              <v-layout pa-3 column fill-height class="white--text">
                <v-spacer></v-spacer>
                <v-flex shrink>
                  <div class="headline">{{ promo.title }}</div>
                </v-flex>
              </v-layout>
            </v-img>

            <v-card-title primary-title class="py-2">
              <v-layout>
                <v-flex>
                  {{ promo.info }}
                </v-flex>
                <v-flex>
                  <v-btn
                    flat
                    round
                    outline
                    v-if="promo.extra"
                    color="secondary"
                    class="initialize right"
                    @click="promo.collapseExtraInfo = !promo.collapseExtraInfo"
                  >
                    <span v-if="promo.collapseExtraInfo">
                      {{ $t('global.button.more') }}
                    </span>
                    <span v-else>
                      {{ $t('global.button.less') }}
                    </span>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card-title>

            <v-spacer></v-spacer>
            <v-card-text
              :hidden="!(promo.extra && !promo.collapseExtraInfo)"
              v-html="promo.extra"
            >
            </v-card-text>

            <v-card-actions class="pa-0">
              <v-btn
                flat
                block
                target="_black"
                :href="promo.action"
                class="primary initialize"
              >
                {{ $t('global.button.go') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-card>
  </v-container>
</template>

<script>
import _ from 'lodash';
import marketingService from '@/services/marketingService';
import { EventBus } from '@/services/eventBus';
import keys from '@/store/keys';

export default {
  name: 'Promos',
  data() {
    return {
      showCardOverlay: true,
      onlyOnePromo: false,
      promos: [],
    };
  },
  created() {
    this.loadPromos();
    EventBus.$on(keys.eventOnLanguageChanged, this.changeLanguage);
  },
  destroyed() {
    EventBus.$off(keys.eventOnLanguageChanged, this.changeLanguage);
  },
  methods: {
    async changeLanguage() {
      await this.loadPromos();
    },
    async loadPromos() {
      let resp = await marketingService.listPromos();
      if (resp.error) {
      } else {
        let promos = resp.data;
        _.each(promos, (promo) => {
          promo.collapseExtraInfo = true;
        });

        this.promos = promos;

        if (this.promos.length !== 0) {
          if (this.promos.length === 1) {
            this.onlyOnePromo = true;
          }
          this.showCardOverlay = false;
        } else {
          this.$router.replace(this.$i18n.t('urlGodfather'));
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.flexcard {
  display: flex;
  flex-direction: column;
}

@keyframes placeHolderShimmer {
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
}

.animated-background {
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: #f6f7f8;
  background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
  background-size: 800px 104px;
  height: 96px;
  position: relative;
}
</style>
